import React, { useEffect, useState } from "react";
import { useProposalContext } from "../..";
import {
  Box,
  TableCell,
  styled,
  Divider,
  Stack,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import MilestoneModal from "../../../../components/MilestoneModal";
import styles from "./styles";
import { Setting } from "../../../../utils/Setting";
import { isArray, isEmpty, set } from "lodash";
import { getApiData } from "../../../../utils/APIHelper";
import moment from "moment";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as NewRenovationIcon } from "../../../../assets/svg/NewRenovationIcon.svg";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { toast } from "react-toastify";
import ConfirmModel from "../../../../components/ConfirmModel";
import { MdOutlineEdit, MdOutlineDelete } from "react-icons/md";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
  padding: "0 !important",
}));

const AddStyledButton = styled(Button)(({ theme }) => ({
  background: "#0000000A",
  color: "#4D6BF6",
  boxShadow: "none",
  border: "none",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function Milestones() {
  const { id } = useParams();
  const { proposalDetails, setProposalDetails } = useProposalContext();
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [selectedDeleteMilestone, setSelectedDeleteMilestone] = useState(null);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (proposalDetails && proposalDetails?.proposal_id) {
      getDetailsApiCall(proposalDetails?.proposal_id);
    }
  }, [proposalDetails?.proposal_id]);

  async function getDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.getProject}?proposal_id=${id}`,
        "GET",
        {}
      );
      if (
        response.success &&
        isArray(response?.data) &&
        !isEmpty(response?.data)
      ) {
        const data = response?.data[0];
        setProposalDetails(data);
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const handleClick = (item) => {
    console.log("item", item);
    // navigate(`/new-create-proposal/${proposalDetails.proposal_id}/${item.id}`);
    navigate(
      `/new-create-proposal/${proposalDetails?.proposal_id}/milestone/${item.id}`,
      {
        state: { milestoneData: item, project: proposalDetails },
      }
    );
  };

  const handlePrevious = () => {
    navigate(`/new-create-proposal/${proposalDetails?.proposal_id}`);
  };

  const handleNext = () => {
    if (!proposalDetails?.milestone?.length) {
      toast.error("Please add at least one milestone to proceed");
      return;
    }

    const hasInvalidDates = proposalDetails.milestone.some(
      (milestone) => !milestone.start_date || !milestone.end_date
    );

    if (hasInvalidDates) {
      toast.error("Every milestone should have a start & end date");
      return;
    }

    navigate(`/new-create-proposal/${proposalDetails?.proposal_id}/budget`);
  };

  const handleCloseModal = () => setSelectedMilestone(null);

  const handleModalClose = () => {
    navigate("/proposals");
  };

  async function handleConfirm() {
    setButtonLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.newSingleMilestone}/${parseInt(
          selectedDeleteMilestone?.id
        )}`,
        "DELETE",
        {},
        { "Content-Type": "application/json" },
        true
      );
      toast.success("Milestone Deleted Successfully");
      setSelectedDeleteMilestone(null);
      getDetailsApiCall(proposalDetails?.proposal_id);
      setButtonLoader(false);
    } catch (error) {
      console.log("err===>", error);
    }
  }

  return (
    <div style={{ ...styles.container, ...styles.columnFlex, gap: "15px" }}>
      <h3 style={styles.heading}>Milestones</h3>
      {loader ? (
        <center>
          <CircularProgress />
        </center>
      ) : (
        <div
          style={{
            ...styles.columnFlex,
            gap: "10px",
          }}
        >
          {proposalDetails?.milestone?.map((item, idx) => (
            <div style={styles.budgetRow} key={item.id}>
              <div
                style={{ ...styles.rowFlex, flex: 1, cursor: "pointer" }}
                onClick={() => handleClick(item)}
              >
                <Box display="flex" alignItems="center">
                  <Box
                    component="img"
                    src={
                      item?.milestone_image
                        ? item?.milestone_image?.path
                        : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                    }
                    alt="Project Icon"
                    sx={{
                      width: 35,
                      height: 35,
                      borderRadius: "8px",
                      border: "2px solid white",
                      boxShadow: "0px 4px 2.67px 0px #00000026",
                      marginRight: 1,
                    }}
                  />
                  <span style={styles.small_sub_heading}>
                    {item?.milestone_name}
                  </span>
                </Box>
              </div>

              <div style={{ ...styles.rowFlex, flex: 1 }}>
                <div style={styles.small_text}>
                  <div style={{ ...styles.rowFlex }}>
                    {item?.tags === "Design" ? (
                      <NewDesignIcon />
                    ) : (
                      <NewRenovationIcon />
                    )}
                    {item?.tags}
                  </div>
                </div>
              </div>

              <div style={{ ...styles.columnFlex, flex: 1 }}>
                <h3 style={styles.small_text}>Start Date</h3>
                <div style={styles.small_sub_heading}>
                  {item?.start_date
                    ? moment(item?.start_date).format("MMM DD, YYYY")
                    : "-"}
                </div>
              </div>
              <div style={{ ...styles.columnFlex, flex: 1 }}>
                <h3 style={styles.small_text}>End Date</h3>
                <div style={styles.small_sub_heading}>
                  {item?.end_date
                    ? moment(item?.end_date).format("MMM DD, YYYY")
                    : "-"}
                </div>
              </div>

              <div style={{ ...styles.columnFlex, flex: 1 }}>
                <h3 style={styles.small_text}>Amount</h3>
                <div
                  style={{
                    ...styles.small_sub_heading,
                    ...styles.rowFlex,
                    gap: "5px",
                  }}
                >
                  {renderCurrencyIcon('small')}
                  {formattedAmountWithoutAed(item?.amount)}
                </div>
              </div>

              <div style={{ ...styles.rowFlex, flex: 0.3 }}>
                <div style={{ ...styles.rowFlex }}>
                  <MdOutlineEdit
                    onClick={() => setSelectedMilestone(item)}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.3rem",
                      color: "#0D0D0E",
                    }}
                  />
                  <MdOutlineDelete
                    style={{
                      cursor: "pointer",
                      fontSize: "1.3rem",
                      color: "#e54746",
                    }}
                    onClick={() => setSelectedDeleteMilestone(item)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <StyledTableCell>
        <AddStyledButton onClick={() => setSelectedMilestone({})}>
          + Add Milestone
        </AddStyledButton>
      </StyledTableCell>

      {selectedMilestone && (
        <MilestoneModal
          isCreationOpen={Boolean(selectedMilestone)}
          visible={Boolean(selectedMilestone)}
          handleCloseCreation={handleCloseModal}
          selectedMilestone={selectedMilestone}
          isEdit={Object.keys(selectedMilestone).length !== 0}
          milestones={proposalDetails?.milestone}
          proposalId={proposalDetails?.proposal_id}
          getProjectDetails={getDetailsApiCall}
          setOuterButtonLoader={setButtonLoader}
        />
      )}

      {selectedDeleteMilestone && (
        <ConfirmModel
          visible={!!selectedDeleteMilestone}
          handleClose={() => setSelectedDeleteMilestone(null)}
          confirmation={handleConfirm}
          message={`Are you sure you want to delete ${selectedDeleteMilestone?.milestone_name}?`}
        />
      )}

      <Divider sx={{ width: "100%" }} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GreyStyledButton onClick={handlePrevious}>
          {buttonLoader ? (
            <CircularProgress size={26} style={{ color: "#fff" }} />
          ) : (
            "Previous Step"
          )}
        </GreyStyledButton>

        <Stack
          alignItems="end"
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
        >
          <GreyStyledButton onClick={handleModalClose}>Cancel</GreyStyledButton>
          <StyledButton variant="contained" onClick={handleNext}>
            {buttonLoader ? (
              <CircularProgress size={26} style={{ color: "#fff" }} />
            ) : (
              "Save & Continue"
            )}
          </StyledButton>{" "}
        </Stack>
      </Stack>
    </div>
  );
}
export default Milestones;
